<template>
  <div class="dflexr-jcc verse-nav">
    <div class="btn btn-all" @click="toggle_showall"
         :class="{ 'show-all-verses': all_verses}" >
      All
    </div>
    <div class="btn btn-prev" @click="$emit('change_verse', 'prev')">-</div>
    <input type="text" class="inp-verse-idx" v-model="vIdx"
      @onChange="$emit('vIdx', vIdx)"
    >
    <div class="btn btn-next" @click="$emit('change_verse', 'next')">+</div>
    <div class="btn btn-shuffle" @click="$emit('shuffle')">
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
           version="1.1" width="24" height="24"
           viewBox="0 0 256 256" xml:space="preserve">

          <g style="stroke: #699ebf; stroke-width: 1;
          stroke-dasharray: none; stroke-linecap: butt;
          stroke-linejoin: miter; stroke-miterlimit: 10;
          fill: none; fill-rule: nonzero; opacity: 1;"
             transform="translate(1.4065934065934016 1.4065934065934016)
             scale(2.81 2.81)" >
	<path d="M 15.376 65.408 H 3 c -1.657 0 -3 -1.343 -3 -3 s 1.343 -3 3
        -3 h 12.376 c 7.905 0 15.391 -4.151 21.081 -11.69 l 6.832 -9.051 c
        6.751 -8.945 16.181 -14.075 25.87 -14.075 h 14.959 c 1.657 0 3 1.343
        3 3 s -1.343 3 -3 3 H 69.158 c -7.904 0 -15.391 4.152 -21.081 11.69
        l -6.832 9.051 C 34.495 60.278 25.065 65.408 15.376 65.408 z"
        style="stroke: none; stroke-width: 1; stroke-dasharray: none;
        stroke-linecap: butt; stroke-linejoin: miter;
        stroke-miterlimit: 10; fill: #699ebf;
        fill-rule: nonzero; opacity: 1;"
        transform=" matrix(1 0 0 1 0 0) "
        stroke-linecap="round" />
            <path d="M 84.117 65.408 H 71.741 c -9.689 0 -19.119 -5.13
        -25.87 -14.075 l -6.832 -9.051 c -5.69 -7.539 -13.177 -11.69
        -21.081 -11.69 H 3 c -1.657 0 -3 -1.343 -3 -3 s 1.343 -3 3 -3
        h 14.958 c 9.688 0 19.118 5.13 25.87 14.076 l 6.832 9.05 c 5.689
        7.539 13.176 11.69 21.081 11.69 h 12.376 c 1.657 0 3 1.343 3 3
        S 85.774 65.408 84.117 65.408 z"
                  style="stroke: none; stroke-width: 1; stroke-dasharray: none;
        stroke-linecap: butt; stroke-linejoin: miter;
        stroke-miterlimit: 10; fill: #699ebf; fill-rule: nonzero;
        opacity: 1;" transform=" matrix(1 0 0 1 0 0) "
                  stroke-linecap="round" />

            <polygon points="79.23,35.37 87,27.59 79.23,19.82 "
                     style="stroke: none; stroke-width: 1; stroke-dasharray: none;
        stroke-linecap: butt; stroke-linejoin: miter;
        stroke-miterlimit: 10; fill: #699ebf; fill-rule: nonzero;
        opacity: 1;" transform="  matrix(1 0 0 1 0 0) "/>

            <path d="M 79.227 38.365 c -0.386 0 -0.775 -0.075 -1.147 -0.229
        c -1.121 -0.464 -1.852 -1.558 -1.852 -2.771 V 19.819 c 0 -1.213
        0.73 -2.307 1.852 -2.771 c 1.123 -0.465 2.413 -0.208 3.27 0.65
        l 7.772 7.772 c 1.172 1.171 1.172 3.071 0 4.242 l -7.772 7.773
        C 80.775 38.06 80.008 38.365 79.227 38.365 z M 82.228 27.062
        v 1.06 l 0.53 -0.53 L 82.228 27.062 z" style="stroke: none;
        stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt;
        stroke-linejoin: miter; stroke-miterlimit: 10; fill: #699ebf;
        fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) "
                  stroke-linecap="round" />

            <polygon points="79.23,70.18 87,62.41 79.23,54.63 "
                     style="stroke: none; stroke-width: 1;
                 stroke-dasharray: none; stroke-linecap: butt;
                 stroke-linejoin: miter; stroke-miterlimit: 10;
                 fill: #699ebf; fill-rule: nonzero; opacity: 1;"
                     transform="  matrix(1 0 0 1 0 0) "/>

            <path d="M 79.227 73.181 c -0.386 0 -0.776 -0.074 -1.147 -0.229
        c -1.121 -0.464 -1.852 -1.558 -1.852 -2.771 V 54.635 c 0 -1.214
        0.731 -2.308 1.852 -2.771 c 1.126 -0.467 2.413 -0.207 3.27 0.65
        l 7.772 7.773 c 1.172 1.172 1.172 3.071 0 4.242 l -7.772 7.772
        C 80.775 72.876 80.008 73.181 79.227 73.181 z M 82.228 61.878
        v 1.061 l 0.53 -0.53 L 82.228 61.878 z" style="stroke: none;
        stroke-width: 1; stroke-dasharray: none; stroke-linecap: butt;
        stroke-linejoin: miter; stroke-miterlimit: 10; fill: #699ebf;
        fill-rule: nonzero; opacity: 1;" transform=" matrix(1 0 0 1 0 0) "
                  stroke-linecap="round" />
</g>
</svg>
    </div>
  </div>
</template>

<script setup>
import {onUpdated, ref} from "vue";

const props = defineProps(['verse_idx', 'allVerses'])
const emit = defineEmits(['change_verse', 'shuffle', 'showall', 'vIdx'])
const all_verses = ref(false)
const vIdx = ref(1)

function toggle_showall() {
  all_verses.value = !all_verses.value
  emit('showall', all_verses.value)
}

onUpdated(function () {
  vIdx.value = props.verse_idx
  all_verses.value = props.allVerses
})

</script>

<style scoped lang="scss">
$color-primary: #a9a07f;
$color-secondary: #172924;
$color-bg-light: rgba(255, 255, 255, 0.01);
$color-bg-hover: rgba(50, 255, 50, 0.25);
$box-shadow-color: rgb(85, 163, 153);
$font-family-main: "Eagle Lake", serif;

.verse-nav {
  margin-top: 1rem;
  max-height: 40px;
}


  input.inp-verse-idx {
    background-color: rgba(255, 255, 255, 0.1);
    color: $color-primary;
    text-align: center;
    width: 3rem;
  }



  .btn {
    background-color: $color-secondary;
    padding-top: 0.5rem;
    line-height: 1rem;

    &:hover {
      background-color: $color-bg-hover;
    }
  }

  .btn-all {
    @extend .btn;
    color: $color-primary;
  }

  .btn-prev {
    @extend .btn;
  }

  .btn-shuffle {
    @extend .btn;
    padding-top: 4px;
    width: 20px;
    height: 24px;
    color: $color-primary;
  }

  .show-all-verses {
    background-color: $color-bg-hover;
  }

</style>


